export enum EquipmentType {
    FeedMixer,
    ManureSpreader,
    Tractor,
    PressureWasher,
    AutomaticFeeder,
    Waterer,
    VentilationFan,
    HeatLamp,
    ManurePump,
    SlurryTanker,
    PigScale,
    FarrowingCrate,
    GestationCrate,
    FencePanel,
    WasteIncinerator,
    InjectionGun,
    PigTransportTrailer,
    CoolingSystem,
    SortingGate,
    PigletWarmer
}

export enum EquipmentTypeLabel {
    FeedMixer = 'Feed Mixer',
    ManureSpreader = 'Manure Spreader',
    Tractor = 'Tractor',
    PressureWasher = 'Pressure Washer',
    AutomaticFeeder = 'Automatic Feeder',
    Waterer = 'Waterer',
    VentilationFan = 'Ventilation Fan',
    HeatLamp = 'Heat Lamp',
    ManurePump = 'Manure Pump',
    SlurryTanker = 'Slurry Tanker',
    PigScale = 'Pig Scale',
    FarrowingCrate = 'Farrowing Crate',
    GestationCrate = 'Gestation Crate',
    FencePanel = 'Fence Panel',
    WasteIncinerator = 'Waste Incinerator',
    InjectionGun = 'Injection Gun',
    PigTransportTrailer = 'Pig Transport Trailer',
    CoolingSystem = 'Cooling System',
    SortingGate = 'Sorting Gate',
    PigletWarmer = 'Piglet Warmer'
}
